import { BellBadgeOutlineIcon } from './BellBadgeOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 42F0733E-F36F-491B-ADC9-AC8ABAF2C0B7
 * name bell-badge-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell-badge-outline.svg
 * tags
 * - Notification 
 */
export const BellNotificationOutlineIcon = BellBadgeOutlineIcon;
export default BellNotificationOutlineIcon